var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoicemail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 7,
    viewBox: "0 0 16 7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "voicemail-bk",
    d: "M7,8.5A3.49,3.49,0,0,1,5.95,11h4.1a3.5,3.5,0,1,1,2.45,1h-9A3.5,3.5,0,1,1,7,8.5Zm-6,0A2.5,2.5,0,1,0,3.5,6,2.5,2.5,0,0,0,1,8.5Zm14,0A2.5,2.5,0,1,0,12.5,11,2.5,2.5,0,0,0,15,8.5Z",
    transform: "translate(0 -5)",
    fill: "#ff3e4a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoicemail);
export default __webpack_public_path__ + "static/media/voicemail.8335fca2861ee36cbe2989d527f4b88a.svg";
export { ForwardRef as ReactComponent };